/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Import_ValidationInputs */

const en_preset_manager_import_validation = /** @type {(inputs: Preset_Manager_Import_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a file`)
};

const fr_preset_manager_import_validation = /** @type {(inputs: Preset_Manager_Import_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez selectionner un fichier`)
};

const de_preset_manager_import_validation = /** @type {(inputs: Preset_Manager_Import_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie eine Datei aus.`)
};

const it_preset_manager_import_validation = /** @type {(inputs: Preset_Manager_Import_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un file`)
};

const ru_preset_manager_import_validation = /** @type {(inputs: Preset_Manager_Import_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите файл.`)
};

const es_preset_manager_import_validation = /** @type {(inputs: Preset_Manager_Import_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor seleccione un archivo`)
};

const zh_cn2_preset_manager_import_validation = /** @type {(inputs: Preset_Manager_Import_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择文件`)
};

const ja_preset_manager_import_validation = /** @type {(inputs: Preset_Manager_Import_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルを選択してください`)
};

const hi_preset_manager_import_validation = /** @type {(inputs: Preset_Manager_Import_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया एक फ़ाइल चुनें`)
};

const pt_pt2_preset_manager_import_validation = /** @type {(inputs: Preset_Manager_Import_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, selecione um arquivo.`)
};

/**
* | output |
* | --- |
* | "Please select a file" |
*
* @param {Preset_Manager_Import_ValidationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_import_validation = /** @type {((inputs?: Preset_Manager_Import_ValidationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Import_ValidationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_import_validation(inputs)
	if (locale === "de") return de_preset_manager_import_validation(inputs)
	if (locale === "it") return it_preset_manager_import_validation(inputs)
	if (locale === "ru") return ru_preset_manager_import_validation(inputs)
	if (locale === "es") return es_preset_manager_import_validation(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_import_validation(inputs)
	if (locale === "ja") return ja_preset_manager_import_validation(inputs)
	if (locale === "hi") return hi_preset_manager_import_validation(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_import_validation(inputs)
	return en_preset_manager_import_validation(inputs)
});